interface DottedArcProps {
  width?: number;
  height?: number;
  color?: 'primary' | 'secondary' | 'accent' | 'neutral';
  opacity?: number;
  direction?: 'left' | 'right';
  variant?: 'dashed' | 'dotted';
  className?: string;
}

export function DottedArc({
  width = 150,
  height = 100,
  color = 'primary',
  opacity = 0.45,
  direction = 'left',
  variant = 'dashed',
  className = ''
}: DottedArcProps) {
  const colorMap: Record<string, string> = {
    primary: 'var(--color-primary-500)',
    secondary: 'var(--color-secondary-500)',
    accent: '#10B981',
    neutral: '#64748b',
  };

  const path = direction === 'left'
    ? `M ${width} ${height * 0.1} Q ${width * 0.3} ${height * 0.3}, ${width * 0.2} ${height}`
    : `M 0 ${height * 0.1} Q ${width * 0.7} ${height * 0.3}, ${width * 0.8} ${height}`;

  const dashArray = variant === 'dotted' ? '3 8' : '10 8';

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      className={className}
      style={{ opacity }}
    >
      <path
        d={path}
        stroke={colorMap[color]}
        strokeWidth={2.5}
        strokeDasharray={dashArray}
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}
